export const PREMIUM_TEAM_SCOUT_MAX_DEMOS_PER_ANALYSIS = 15;
export const FREE_TEAM_SCOUT_MAX_DEMOS_PER_ANALYSIS = 5;
export const PREMIUM_SCOUT_ANALYSES_PER_WEEK = 5;
